const ensureTrailingAndLeadingSlash = (url, removeTrailingSlash) =>
  `/${url}${removeTrailingSlash ? '' : '/'}`.replace(/\/\//g, '/')

export const parseURL = (url, removeTrailingSlash = false) => {
  if (Array.isArray(url)) {
    return ensureTrailingAndLeadingSlash(url.join('/'), removeTrailingSlash)
  }
  return ensureTrailingAndLeadingSlash(url, removeTrailingSlash)
}
